export default __webpack_public_path__ + "static/media/restaurant.04e580ec.svg";